<template>
    <div>
      <responsible-field-list></responsible-field-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  